type EventHandler<T = unknown> = (payload: T) => void;

class EventBus {
  private handlers = new Map<string, Set<EventHandler>>();

  on<T = unknown>(event: string, handler: EventHandler<T>): () => void {
    if (!this.handlers.has(event)) {
      this.handlers.set(event, new Set());
    }
    this.handlers.get(event)!.add(handler as EventHandler);

    // Return unsubscribe function
    return () => {
      this.handlers.get(event)?.delete(handler as EventHandler);
    };
  }

  emit<T = unknown>(event: string, payload: T): void {
    const handlers = this.handlers.get(event);
    if (handlers) {
      handlers.forEach((handler) => {
        try {
          handler(payload);
        } catch (error) {
          console.error(`Error in event handler for ${event}:`, error);
        }
      });
    }
  }

  off(event: string, handler?: EventHandler): void {
    if (handler) {
      this.handlers.get(event)?.delete(handler);
    } else {
      this.handlers.delete(event);
    }
  }

  clear(): void {
    this.handlers.clear();
  }
}

export const eventBus = new EventBus();

export const HR_ROUTES = {
  NOTIFICATIONS: '/hr/notifications',
} as const;

// Predefined ERP event types
export const ERP_EVENTS = {
  FINANCE_JOURNAL_POSTED: 'finance:journal-posted',
  HR_PAYROLL_PROCESSED: 'hr:payroll-processed',
  HR_NOTIFICATION_CREATED: 'hr:notification-created',
  GRAPHICS_JOB_CREATED: 'graphics:job-created',
  GRAPHICS_JOB_COMPLETED: 'graphics:job-completed',
  SYSTEM_COMPANY_SWITCHED: 'system:company-switched',
  SYSTEM_USER_LOGGED_OUT: 'system:user-logged-out',
  SYSTEM_PERMISSION_CHANGED: 'system:permission-changed',
  NOTIFICATION_CREATED: 'notification:created',
} as const;
